import { ConfigService } from "./../config-service/config.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  TrainingRequest,
  TrainingRequestItem,
  TrainingRequestStatus,
} from "@stockcare-models/TraningRequest";

@Injectable({
  providedIn: "root",
})
export class TrainingRequestService {
  constructor(
    private http: HttpClient,
    private configurationService: ConfigService
  ) {}

  getAll() {
    return this.http.get<TrainingRequestItem[]>(
      `${this.configurationService.config.baseUrl}/TrainingRequest/GetAll`
    );
  }

  getByInstitution(institutionId: number) {
    return this.http.get<TrainingRequestItem[]>(
      `${this.configurationService.config.baseUrl}/TrainingRequest/GetByInstitution/${institutionId}`
    );
  }

  getAllStatuses() {
    return this.http.get<TrainingRequestStatus[]>(
      `${this.configurationService.config.baseUrl}/TrainingRequest/GetAllStatuses`
    );
  }

  request(trainingRequest: TrainingRequest) {
    return this.http.post<any[]>(
      `${this.configurationService.config.baseUrl}/TrainingRequest/RequestTraining`,
      trainingRequest
    );
  }

  update(trainingRequest: TrainingRequestItem) {
    const data = {
      correlationId: trainingRequest.correlationId,
      status: trainingRequest.status,
    };

    return this.http.post<any[]>(
      `${this.configurationService.config.baseUrl}/TrainingRequest/Update`,
      data
    );
  }
}
